module.exports = __webpack_public_path__ + "/a46ce7d562532cb0e41897207a5ec11c.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/assets/oracle_logo.svg
 ** module id = 1624
 ** module chunks = 0
 **/